import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { SignoAuditoriaEvento } from '@interfaces/interface-bakend/auditoria/signo-auditoria-evento.interface';
import { describirEvento, labelAccion, labelModulo, labelPantalla } from '../diccionario/auditoria-diccionario';

@Component({
    selector: 'app-auditoria-detalle',
    templateUrl: './auditoria-detalle.component.html',
    styleUrls: ['./auditoria-detalle.component.scss'],
})
export class AuditoriaDetalleComponent implements OnInit {

    modulo: string = '';
    evento: SignoAuditoriaEvento | null = null;
    flagLoaded: boolean = false;
    descripcion: string = '';
    payloadEntries: Array<{ clave: string; valor: string }> = [];

    labelAccion = labelAccion;
    labelModulo = labelModulo;
    labelPantalla = labelPantalla;

    constructor(
        private router: Router,
        private signoAuditoriaService: SignoAuditoriaService,
    ) {}

    async ngOnInit(): Promise<void> {
        if (!(await this.signoAuditoriaService.puedeAccederAuditoria())) {
            this.signoAuditoriaService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }
        this.evento = this.signoAuditoriaService.getEventoSeleccionado() || null;
        this.modulo = this.signoAuditoriaService.getModuloSeleccionado();
        if (!this.evento) {
            this.router.navigateByUrl('/menu-auditoria');
            return;
        }
        this.descripcion = describirEvento(this.evento);
        this.payloadEntries = Object.entries(this.evento.payload || {}).map(([clave, valor]) => ({
            clave,
            valor: this.formatValor(valor),
        }));
        this.flagLoaded = true;
    }

    private formatValor(valor: any): string {
        if (valor === null || valor === undefined) { return '-'; }
        if (typeof valor === 'boolean') { return valor ? 'Sí' : 'No'; }
        if (typeof valor === 'object') { return JSON.stringify(valor); }
        return `${valor}`;
    }

    volver(): void {
        this.router.navigateByUrl('/auditoria-listado');
    }
}
